
import React, { useRef } from 'react';
import SolutionHeader from './solution/SolutionHeader';
import Dashboard from './solution/Dashboard';
import SolutionFeatures from './solution/SolutionFeatures';
import FeatureCards from './solution/FeatureCards';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';

const Solution = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  
  useIntersectionObserver({ ref: sectionRef });

  return (
    <section
      id="solutions"
      ref={sectionRef}
      className="py-24 bg-gradient-to-b from-white to-blue-50 relative overflow-hidden"
    >
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-radial from-blue-100/30 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-gradient-radial from-blue-100/30 to-transparent"></div>
      
      <div className="container mx-auto px-4">
        <SolutionHeader />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 max-w-6xl mx-auto">
          <Dashboard />
          <SolutionFeatures />
        </div>
        
        <FeatureCards />
      </div>
    </section>
  );
};

export default Solution;
